import { capitalizeAllIfLower } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useOpenEditServiceOrdersUserModal } from '../../utils/routes/modals/modalsActions'
import { useServiceOrderPermissions } from '../../utils/permissions/serviceOrders/serviceOrderPermissions'
import HoverIconText from '../../components/actions/HoverIconText'

const EditableServiceOrdersUser = ({ serviceOrder }) => {
  const { t } = useTranslation('serviceOrders')
  let { canEditUser } = useServiceOrderPermissions(serviceOrder)
  const canSeeOnlySelfSOs = useSessionPermission('seeOnlySelfServiceOrders')
  canEditUser = canEditUser && !canSeeOnlySelfSOs

  const openEditServiceOrdersUserModal = useOpenEditServiceOrdersUserModal()

  const isCompleted = serviceOrder?.status?.name === 'completed'
  const isAnonymousResponse = serviceOrder?.user === null && !canEditUser && isCompleted
  const userName = isAnonymousResponse ? t('anonymousResponse') : serviceOrder?.user?.name

  const groupOrGroupsNames = serviceOrder?.groups?.map(group => group.name).join(', ') || serviceOrder?.group?.name

  return (
    <HoverIconText
      label={capitalizeAllIfLower(userName || groupOrGroupsNames)}
      emptyLabel={canEditUser && t('selectUser')}
      onClick={canEditUser && (() => openEditServiceOrdersUserModal(serviceOrder))}
      multiple={serviceOrder?.groups?.length > 2}
    />
  )
}

export default EditableServiceOrdersUser
